import { NgModule } from '@angular/core';
import { LoginLayoutComponent } from './common/layout/login-layout.component';
import { LoginComponent } from './auth/login/login.component';
import { AuthGuard } from './base/auth.guard';
import { AdminAuthGuard } from './base/admin.auth.guard';
import { Routes, RouterModule } from '@angular/router';
import { SuppliesElementComponent } from './supplies-element/supplies-element.component';
import { HomeLayoutComponent } from './common/layout/home-layout.component';
// import { HomeLayoutComponent } from './common/layout/home-layout.component';
// import { AuthGuard } from './base/auth.guard';
// import { BlankLayoutComponent } from './common/layout/blank-layout.component';
// import { SSOComponent } from './auth/login/sso.component';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { AdminAuthGuard } from './base/admin.auth.guard';
// import { CRMComponent } from './auth/login/crm.component';
// AThis code is done by great nitish.
// const routes: Routes = [
//   { path: 'login/:viuser', component: LoginComponent },
//   {path:'home',component:HomeLayoutComponent},
//    { path: 'embed' , component: SuppliesElementComponent },
//    { path: '**', component: LoginComponent }
//   // { path: 'sso', component: SSOComponent },
//   // { path: 'admin', component: HomeLayoutComponent, loadChildren: './base/vitalaxis-admin.module#VitalAxisAdminModule', canActivate: [AdminAuthGuard] },
//   // { path: 'crm', component: CRMComponent },
// ];
const routes: Routes = [ 
  // { path: '', component: LoginComponent },
  // { path: 'login/:viuser', component: LoginComponent },
    // { path: '',component: HomeLayoutComponent, loadChildren:'./base/base.module#VitalSuppliesBaseModule'},

  { path: '',component: LoginLayoutComponent, loadChildren:'./auth/login/login.module#LoginModule' },
  { path: 'login/:viuser',component: LoginLayoutComponent, loadChildren:'./auth/login/login.module#LoginModule' },
  { path: 'home',component: HomeLayoutComponent, loadChildren:'./base/base.module#VitalSuppliesBaseModule'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [AuthGuard, AdminAuthGuard]
})
export class AppRoutingModule { }

